import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VIDEO_FEATURE_KEY, VideoState, videoAdapter } from './video.reducer';
import { selectParamParagraphProgressSeenVideos } from '../paragraph-progress/paragraph-progress.selectors';
import { VideoWithWatched } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { selectParamParagraphVideoIds } from '../paragraph/paragraph.selectors';

export const selectVideoState =
  createFeatureSelector<VideoState>(VIDEO_FEATURE_KEY);

const { selectAll } = videoAdapter.getSelectors();

export const selectAllVideos = createSelector(
  selectVideoState,
  (state: VideoState) => selectAll(state),
);

export const selectParamParagraphVideos = createSelector(
  selectAllVideos,
  selectParamParagraphVideoIds,
  (videos, videoIds) => videos.filter((video) => videoIds.includes(video.id)),
);

export const selectParamParagraphVideosWithWatched = createSelector(
  selectParamParagraphVideos,
  selectParamParagraphProgressSeenVideos,
  (videos, seenVideos): VideoWithWatched[] =>
    videos.map((video) => {
      return {
        video,
        watched: seenVideos.includes(video.id),
      };
    }),
);
